/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupServicePriceApiRequest } from '../../models/hotel-edit-group-service-price-api-request';

export interface ApiHotelManageEditGroupServicePricePost$Params {
      body: HotelEditGroupServicePriceApiRequest
}

export function apiHotelManageEditGroupServicePricePost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupServicePricePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupServicePricePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupServicePricePost.PATH = '/api/hotel/manage/edit/group/service-price';
